import { FC } from 'react';

import StatPageSideBar from '@shared/components/StatPageSideBar';

import { AgencyGiftSettlementUnifiedContainer } from '../containers/AgencyGiftSettlementUnified/AgencyGiftSettlementUnifiedContainer';

/**
 * 답례품 정산 통합 페이지 (상조 전용) — 월별 합계 + 배송형/쿠폰형 탭.
 * 사이드바 레이아웃 + 컨테이너 마운트.
 */
export const AgencyAdminGiftSettlementUnifiedPage: FC = () => (
  <div className="flex">
    <div className="flex flex-col">
      <StatPageSideBar />
    </div>
    <div className="mx-auto max-w-screen-2xl flex-1 px-10 py-8">
      <AgencyGiftSettlementUnifiedContainer />
    </div>
  </div>
);
